// extracted by mini-css-extract-plugin
export default {"container":"iBTk","roleWrapper":"XSnQ","role":"DkA8"};